<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :class="`color-fill-${color}`"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99984 14.6666C6.44428 14.2778 5.1665 13.375 4.1665 11.9583C3.1665 10.5416 2.6665 8.98887 2.6665 7.29998V3.33331L7.99984 1.33331L13.3332 3.33331V7.29998C13.3332 8.98887 12.8332 10.5416 11.8332 11.9583C10.8332 13.375 9.55539 14.2778 7.99984 14.6666ZM7.99984 13.6333C9.17762 13.2444 10.1526 12.5305 10.9248 11.4916C11.6971 10.4528 12.1498 9.28887 12.2832 7.99998H7.99984V2.41665L3.6665 4.03331V7.29998C3.6665 7.43331 3.66928 7.5472 3.67484 7.64165C3.68039 7.73609 3.69428 7.85554 3.7165 7.99998H7.99984V13.6333Z"
    />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'shuttle-gray',
});
</script>
